package com.sweetlime.dungeonamigo.di

import org.koin.core.context.startKoin

fun initKoin() {
    startKoin {
        modules(appModule, webHttpModule)
    }
}
